import React, { useState, useCallback } from 'react';
import { Form, Select } from 'antd';
import InputText from '../../common/Inputs/InputText';
import UploadFile from '../../common/UploadFile/UploadFile';
import Button from '../../common/Button/Button';

const DocumentDownload = ({ setDocumentDownload, company, onSubmitDocument }) => {
  const [form] = Form.useForm();
  const [isValid, setIsValid] = useState(false);

  const checkFormValid = useCallback(() => {
    const hasErrors = form
      .getFieldsError()
      .some(({ errors }) => errors.length);

    const values = form.getFieldsValue();
    const allFilled =
      values.document_name &&
      values.company_edrpou &&
      values.document_base64_content;

    setIsValid(!hasErrors && !!allFilled);
  }, [form]);

  const handleFinish = (values) => {
    const [meta, content] = values.document_base64_content.split(',');

    onSubmitDocument({
      itemId: Date.now(),
      document_name: values.document_name,
      company_edrpou: values.company_edrpou,
      document_base64_meta: `${meta},`,
      document_base64_content: content,
    });


  };

  return (
    <div className="documents">
      <div className="documents-tab-wrap">
        <div className="button-back" onClick={() => setDocumentDownload(false)}>
          <span>
            <img src="/icons/arrow-back.svg" />
          </span>
          <span>Назад до документів</span>
        </div>
      </div>

      <div className="documents-tab-content box-shadow">
        <div className="form-wrap">
          <h1>Створити документ</h1>
          <p>Завантажте вхідний документ, який необхідно надіслати постачальнику</p>
          <div className="divider"></div>
        </div>

        <Form
          form={form}
          className="form-download"
          onFieldsChange={checkFormValid}
          onFinish={handleFinish}
        >
          <div className="item">
            <label>Назва документу</label>
            <Form.Item
              name="document_name"
              rules={[{ required: true, message: 'Вкажіть назву' }]}
              className="field"
            >
              <InputText />
            </Form.Item>
          </div>

          <div className="item item__gap">
            <label>Контрагент</label>
            <Form.Item
              name="company_edrpou"
              rules={[{ required: true, message: 'Оберіть контрагента' }]}
              className="field"
            >
              <Select
                placeholder="Виберіть"
                suffixIcon={<img src="/icons/arrow-select.svg" />}
              >
                {company.map(({ name, edrpou }) => (
                  <Select.Option key={edrpou} value={edrpou}>
                    {name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>

          <div className="item">
            <label>Завантажити файл (*.pdf)</label>
            <Form.Item
              name="document_base64_content"
              className="field"
              rules={[{ required: true, message: 'Завантажте PDF файл' }]}
            >
              <UploadFile label="Завантажити файл" />
            </Form.Item>
          </div>

          <div className="documents-download">
            <Button
              disabled={!isValid}
              typeHtml="submit"
              type="primary"
              text="Продовжити"
            />
          </div>
        </Form>
      </div>
    </div>
  );
};

export default DocumentDownload;
